import { useBankTransactionsFilters } from '@features/bankTransactions/hooks/useBankTransactionsFilters'

import { useSandboxModeContext } from '../contexts/sandboxModeContext'

/**
 * Thin wrapper around useBankTransactionsFilters that threads the sandbox override through from
 * context, so call sites inside this page tree don't each have to read the context and build the
 * option object themselves — mirrors useSandboxBankAccountByBookkeepingAccountId and friends.
 */
export const useSandboxBankTransactionsFilters = () => {
  const sandbox = useSandboxModeContext()

  return useBankTransactionsFilters({
    sandboxFilters: sandbox?.filters,
    setSandboxFilters: sandbox?.setFilters,
  })
}
